// TrichoAnalysisListPage.jsx
import "./TrichoAnalysisListPage.scss";

import { Col, Row } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { faAdd, faMicroscope } from "@fortawesome/free-solid-svg-icons";

import AppLoading from "../../../../../../commons/AppLoading";
import EmptyState from "../../../../../../commons/EmptyState";
import FloatingButton from "../../../../../../commons/buttons/FloatingButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import HallAppToast from "../../../../../../commons/HallAppToast";
import MenuTitle from "../../../../../../commons/menu/MenuTitle";
import TrichoAPI from "../../../api/TrichoAPI";
import TrichoAnalysisCard from "../components/TrichoAnalysisCard";
import { useNavigate } from "react-router-dom";

const trichoAnalysisAPI = new TrichoAPI();

function TrichoAnalysisListPage() {
  const [isLoading, setIsLoading] = useState(true);
  const [items, setItems] = useState([]);
  const navigate = useNavigate();

  const load = async () => {
    try {
      setIsLoading(true);
      const res = await trichoAnalysisAPI.fetchTrichoAnalyses();
      const data = res?.data || res;
      const list = data?.items || data;
      setItems(Array.isArray(list) ? list : []);
    } catch (e) {
      setItems([]);
      HallAppToast.genericError();
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const open = (a) => {
    // ajuste a rota conforme seu app
    navigate(`/analise-tricoscopica/${a?.id}`);
  };

  const openCreate = () => {
    // se você tiver modal, troca por setShowModal(true)
    navigate(`/analise-tricoscopica`);
  };

  const edit = (a) => {
    navigate(`/analise-tricoscopica/${a?.id}`);
  };

 
  return (
    <>
      <div className="container tricho-analysis-page">
        <MenuTitle
          title="Tricoscopia"
          subtitle="Listagem das análises do seu estabelecimento."
          showArrowInfo={false}
        />

        {isLoading ? (
          <AppLoading />
        ) : (
          <Row className="g-3" style={{ margin: 0, width: "100%" }}>
            {items.length === 0 ? (
              <EmptyState
                title="Nenhuma análise encontrada"
                description="Crie sua primeira análise de tricoscopia para começar a registrar imagens e marcações."
                icon={<FontAwesomeIcon icon={faMicroscope} />}
                actionLabel="Criar minha primeira análise"
                onAction={openCreate}
              />
            ) : (
              items.map((a) => (
                <Col xs={12} sm={6} md={4} lg={4} key={a.id} className="mb-3">
                  <TrichoAnalysisCard
                    item={a}
                    onOpen={open}
                    onEdit={edit}
                    onDelete={load}
                  />
                </Col>
              ))
            )}

            {/* Espaçamento para o FloatingButton não cobrir o último card */}
            <div style={{ height: "calc(50px + 72px)" }}></div>
          </Row>
        )}
      </div>

      <FloatingButton icon={faAdd} onClick={openCreate} />
    </>
  );
}

export default TrichoAnalysisListPage;
